var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed-container mx-auto"},[_c('b-row',{staticClass:"no-gutters"},[_c('b-col',{staticClass:"posts-container"},_vm._l((_vm.posts),function(post,index){return _c('PostItem',{key:index,ref:"posts",refInFor:true,attrs:{"post":post}})}),1),_c('b-col',{staticClass:"col-4 pt-4 suggestions-container"},[_c('Suggestions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }